import React from 'react';
import { ZapIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  sublabel?: string;
  size?: 'md' | 'lg';
  className?: string;
};
export function CtaButton({
  label,
  sublabel,
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const pad = size === 'lg' ? 'px-5 py-4 sm:py-5' : 'px-5 py-3.5';
  const text = size === 'lg' ? 'text-base sm:text-lg' : 'text-sm sm:text-base';
  return <div className={`w-full ${className}`} data-id="element-29" data-mp="qih85l17w9j9">
      <a href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-xl bg-ember ${pad} text-center font-extrabold uppercase tracking-wide text-white shadow-[0_10px_0_0_#a83f00] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-[#ff7d1f] active:translate-y-[6px] active:shadow-[0_4px_0_0_#a83f00] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal-bright ${text}`} data-id="element-30" data-mp="lm0gwhyq1f1y">
        <ZapIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-31" data-mp="35xxukwcpwzvx" />
        <span className="leading-tight" data-id="element-32" data-mp="39yrhpnic6anr">{label}</span>
      </a>
      {sublabel ? <p className="mt-3 text-center text-[11px] font-medium uppercase tracking-wider text-white/50 sm:text-xs" data-id="element-33" data-mp="3a0kor3wv2wwa">
          {sublabel}
        </p> : null}
    </div>;
}